import React from "react";
import { Box } from "@mui/system";
import { Typography, Button } from "@mui/material";
import ArrowBack from "@mui/icons-material/ArrowBack";
import ArrowForward from "@mui/icons-material/ArrowForward";
import NotificationBar from "components/shared/notification-bar";

export function QuestionFooter({ back, onSave, isValid, showErrorModal = "" , isSubmitting}:any) {
  return (
    <Box display="flex" justifyContent={"space-between"}>
      {!isValid && (
        <NotificationBar successMessage={null} errorMessage={showErrorModal} />
      )}
      <Button startIcon={<ArrowBack />} type="button" onClick={back}>
        <Typography color="#238CB9" fontSize={"16px"} fontWeight={"bold"}>
          ZURÜCK
        </Typography>
      </Button>
      <Button disabled={!isValid || isSubmitting} endIcon={<ArrowForward />} type="button" onClick={onSave}>
        <Typography
          color="#238CB9"
          fontSize={"16px"}
          fontWeight={"bold"}
        >
         {isSubmitting ? 'LADEN...' :' WEITER'}
        </Typography>
      </Button>
    </Box>
  );
}
